import http, {httpGet} from './http.service';

export class TagsService {
  load() {
    return httpGet('/tags').then(response => response.data);
  }

  findOrCreateTagByName(name) {
    return http.get(`/tags/${name}`).then(response => response.data);
  }
}
